import { render, staticRenderFns } from "./LangSelector.vue?vue&type=template&id=08a8c5b2"
import script from "./LangSelector.vue?vue&type=script&lang=js"
export * from "./LangSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.41_babel-core@7.0.0-bridge.0_@babel+core@7.29._a26fb9023b752f5df33ae8450879cd09/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports